import { defineNuxtPlugin } from '#app/nuxt'
import { LazySingleTicker, LazyTicker, LazySymbolInfo, LazyStockMarket, LazyStockHeatMap, LazyScreener, LazyMiniChart, LazyMarketOverview, LazyMarketData, LazyTickerTape, LazyFundamentalData, LazyForexHeatMap, LazyForexCrossRates, LazyEconomicCalendar, LazyTechnicalAnalysis, LazyCryptoMarket, LazyCryptoHeatMap, LazyCompanyProfile, LazyChart, LazySymbolOverview, LazyTopStories } from '#components'
const lazyGlobalComponents = [
  ["SingleTicker", LazySingleTicker],
["Ticker", LazyTicker],
["SymbolInfo", LazySymbolInfo],
["StockMarket", LazyStockMarket],
["StockHeatMap", LazyStockHeatMap],
["Screener", LazyScreener],
["MiniChart", LazyMiniChart],
["MarketOverview", LazyMarketOverview],
["MarketData", LazyMarketData],
["TickerTape", LazyTickerTape],
["FundamentalData", LazyFundamentalData],
["ForexHeatMap", LazyForexHeatMap],
["ForexCrossRates", LazyForexCrossRates],
["EconomicCalendar", LazyEconomicCalendar],
["TechnicalAnalysis", LazyTechnicalAnalysis],
["CryptoMarket", LazyCryptoMarket],
["CryptoHeatMap", LazyCryptoHeatMap],
["CompanyProfile", LazyCompanyProfile],
["Chart", LazyChart],
["SymbolOverview", LazySymbolOverview],
["TopStories", LazyTopStories],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
